import React, { useContext } from 'react';
import { ThemeContext } from '../theme';

const SCALE = 0.75;
const s = (n) => Math.round(n * SCALE);

export default function FilterChip({ label, active = false, onClick }) {
  const theme = useContext(ThemeContext);
  return (
    <button
      onClick={onClick}
      className="font-satoshi"
      style={{
        padding: `${s(8)}px ${s(24)}px`,
        borderRadius: s(20),
        border: active ? 'none' : `1px solid ${theme.border}`,
        backgroundColor: active ? theme.btnPrimaryBg : theme.cardBg,
        color: active ? theme.btnPrimaryText : theme.text200,
        fontSize: s(16),
        lineHeight: `${s(24)}px`,
        fontWeight: 500,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      {label}
    </button>
  );
}
